<template>
	<select class="customSelect" :disabled="disabled" @change="$emit('input', $event.target.value)">
		<option v-if="placeholder" :value="null" disabled>{{ placeholder }}</option>
		<option v-for="option in options" :key="option.text" :value="option.text" :selected="value === option.text">{{ option.text }}</option>
	</select>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: null,
		},
		options: {
			type: Array,
			default: [],
		},
		value: {},
	},
})
</script>
